import { getVideoModal } from './VideoModal';
import { buildYoutubeIframe } from '../utils/youtubeEmbed';

// Doit rester aligne sur le breakpoint lg de scss/abstracts/_variables.scss.
const DESKTOP_MEDIA_QUERY = '(min-width: 992px)';

// Lecture inline en cours (mobile). Le lecteur inline est exclusif : sans cela,
// ouvrir un second temoignage laisserait la premiere iframe en place, avec deux
// bandes-son simultanees et aucun moyen d'arreter la premiere.
let $inlinePlaying = null;

/**
 * Bloc temoignage video (cf. Views/Shared/_VideosTemoignages.cshtml).
 *
 * L'iframe n'est construite qu'au clic : aucune requete n'est faite vers
 * YouTube tant que l'utilisateur n'a pas explicitement demande la lecture.
 *
 * Desktop : lecture dans la popup mutualisee, avec navigation entre les blocs.
 * Mobile   : lecture inline dans le bloc, le lecteur natif de l'OS prend
 *            le relais pour le plein ecran.
 */
export default class CardVideo extends HTMLDivElement {

    constructor() {
        super();
        this.videoId = this.dataset.videoId;
        this.videoTitle = this.dataset.videoTitle;
        this.$videoPreview = this.querySelector('.js-video-preview');
        this.$videoPlaceholder = this.querySelector('.js-video-placeholder');
    }

    connectedCallback() {

        if (!this.videoId || !this.$videoPreview || !this.$videoPlaceholder) {
            return;
        }

        this.$videoPreview.addEventListener('click', () => this.play());
    }

    play() {

        if ($inlinePlaying && $inlinePlaying !== this) {
            $inlinePlaying.stopInline();
        }

        if (window.matchMedia(DESKTOP_MEDIA_QUERY).matches) {
            this.playInModal();
        } else {
            this.playInline();
        }

    }

    playInModal() {

        const modal = getVideoModal();

        if (!modal) {
            this.playInline();
            return;
        }

        // La playlist suit l'ordre des cartes dans la page : le partial peut
        // ainsi en contenir un nombre quelconque sans toucher au JS.
        const $cards = Array.from(document.querySelectorAll('.card-video'));

        const playlist = $cards.map(($card) => ({
            videoId: $card.dataset.videoId,
            title: $card.dataset.videoTitle || ''
        }));

        modal.open(playlist, Math.max($cards.indexOf(this), 0));
    }

    playInline() {

        this.$videoPreview.style.display = 'none';
        this.$videoPlaceholder.style.display = 'block';
        this.$videoPlaceholder.appendChild(buildYoutubeIframe(this.videoId, this.videoTitle));

        $inlinePlaying = this;
    }

    /**
     * Retire l'iframe : c'est ce qui coupe la lecture et rend la vignette
     * cliquable a nouveau.
     */
    stopInline() {

        this.$videoPlaceholder.innerHTML = '';
        this.$videoPlaceholder.style.display = '';
        this.$videoPreview.style.display = '';

        if ($inlinePlaying === this) {
            $inlinePlaying = null;
        }

    }

}
